 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTHTITLE from '@/components/Text/htitle'
 import TEXTBOOKS_BY from '@/components/Text/books_by'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOP from '@/components/Text/cop'
 import TEXTFM from '@/components/Text/fm'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTITR from '@/components/Text/itr'
 import TEXTACK from '@/components/Text/ack'
 import TEXTC01 from '@/components/Text/c01'
 import TEXTC02 from '@/components/Text/c02'
 import TEXTC02A from '@/components/Text/c02a'
 import TEXTC03 from '@/components/Text/c03'
 import TEXTC04 from '@/components/Text/c04'
 import LOVE_2 from '@/components/love_2'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTIND from '@/components/Text/ind'
 import TEXTBM from '@/components/Text/bm'
 import TEXTATA from '@/components/Text/ata'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/itr",
 			"name" : "Text/itr",
 			"component" : TEXTITR
 		},
 		{
 			"path" : "/Text/ack",
 			"name" : "Text/ack",
 			"component" : TEXTACK
 		},
 		{
 			"path" : "/Text/c01",
 			"name" : "Text/c01",
 			"component" : TEXTC01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js